var _excluded = ["state"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { createContext, useContext, useMemo, useReducer } from 'react';
import { reducer, initialState } from './utils';
var MainContext = createContext();
MainContext.displayName = 'MainContext';
export var MainProvider = function MainProvider(_ref) {
  var _ref$state = _ref.state,
      state = _ref$state === void 0 ? initialState : _ref$state,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useReducer = useReducer(reducer, state),
      context = _useReducer[0],
      dispatch = _useReducer[1];

  var value = useMemo(function () {
    return [context, dispatch];
  }, [context]);
  return /*#__PURE__*/React.createElement(MainContext.Provider, _extends({
    value: value
  }, props));
};
export var useMainContext = function useMainContext() {
  var _useContext = useContext(MainContext),
      context = _useContext[0],
      dispatch = _useContext[1];

  if (!context) {
    throw new Error('useMainContext must be used in the MainProvider');
  }

  return [context, dispatch];
};
export { dispatchVisitingViaUrl, dispatchSearchOpened } from './utils';